import menuItems from "./menuItems.json";
import { NavLink } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { LangContext, CanvasContext } from "../App";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import CodeRoundedIcon from "@mui/icons-material/CodeRounded";
import TerminalRoundedIcon from "@mui/icons-material/TerminalRounded";
import FolderSpecialRoundedIcon from "@mui/icons-material/FolderSpecialRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import HandshakeRoundedIcon from "@mui/icons-material/HandshakeRounded";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";

export default function Menu({ isOpen, changeData }) {
  const [active, setActive] = useState(true);
  const lang = useContext(LangContext);
  const [chooseLang, setChooseLang] = useState("PL");
  const canvas = useContext(CanvasContext);

  const iconMap = {
    HomeRounded: HomeRoundedIcon,
    CodeRounded: CodeRoundedIcon,
    TerminalRounded: TerminalRoundedIcon,
    FolderSpecialRounded: FolderSpecialRoundedIcon,
    EmailRounded: EmailRoundedIcon,
    HandshakeRounded: HandshakeRoundedIcon,
    HelpOutlineRounded: HelpOutlineRoundedIcon,
  };

  function clickedHandler() {
    const newLang = lang === "pl" ? "en" : "pl";
    changeData(newLang);
    setChooseLang(newLang === "pl" ? "EN" : "PL");
  }

  useEffect(() => {
    if (lang === "pl") {
      setChooseLang("EN");
    }
    if (lang === "en") {
      setChooseLang("PL");
    }
  }, [lang]);

  function handleActive(val) {
    setActive(val);
  }
  return (
    <CanvasContext.Provider value={canvas}>
      <ul className={`main-nav ${isOpen ? "active" : ""}`}>
        {menuItems.map((item) => {
          const IconComponent = iconMap[item.icon];

          return (
            <li key={item.id}>
              <NavLink to={item.name}>
                <p
                  onClick={() => handleActive(item)}
                  className={`nav-item-lato ${active === item ? "active" : ""}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {IconComponent && (
                    <IconComponent sx={{ fontSize: "1.2rem", flexShrink: 0 }} />
                  )}
                  <FormattedMessage id={item.name} />
                </p>
              </NavLink>
            </li>
          );
        })}

        <li>
          <p className="nav-item-lato" onClick={clickedHandler}>
            {chooseLang}
          </p>
        </li>
      </ul>
    </CanvasContext.Provider>
  );
}
